import React from 'react';
import { BrowserRouter as Router } from "react-router-dom";
import './styles/app.scss';
import Layout from './app/layout/Layout';
import AppRoutes from './app/routes/Routes';

const App: React.FC = () => {
  return (
    <Router>
      <Layout>
        <AppRoutes />
      </Layout>
    </Router>
  );
};

export default App;